import { useEffect, useState } from "react";
import ChannelsService from "../../domain/services/Channels/Channels.service";
import { omuniChannels } from "../../app/conf";

const useGetChannels = () => {
  const [data, setData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState(null);

  const controller = new AbortController();

  const Service = new ChannelsService();

  const get = async () => {
    try {

      setIsLoading(true);

      const token = omuniChannels;

      const response = await Service.getChannelsData({
        token,
        signal: controller.signal,
      });

      setData(response.channels);
    } catch (error) {
      setError(error);
    }finally{
      setIsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, []);

  return { data, isLoading, error, get };
};

export default useGetChannels;
